import Export from '@/components/Studies/Export/Export';
import StudyExports from '@/components/Studies/StudyExports/StudyExports';
import { featuresSelector } from '@/support/Selectors';
import { createSelector } from '@reduxjs/toolkit';
import type { FC } from 'react';
import { useSelector } from 'react-redux';

const featureSelector = createSelector([featuresSelector], (features) => ({
  asyncExportsEnabled: features.async_exports === true,
}));

const StudyExportsContainer: FC = () => {
  const { asyncExportsEnabled } = useSelector(featureSelector);

  return asyncExportsEnabled ? <StudyExports /> : <Export />;
};

export default StudyExportsContainer;
